import SVTextInput from './SVTextInput';
import { useFormContext } from 'react-hook-form';

interface SVPhoneInputProps {
  label: string;
  name: string;
  validateMatch?: string;
  bypassValidation?: boolean;
  disabled?: boolean;
}

export default function SVPhoneInput({
  label,
  name,
  validateMatch,
  bypassValidation = false,
  disabled = false,
}: SVPhoneInputProps) {
  const formMethods = useFormContext();
  const matchValue = validateMatch ? formMethods.watch(validateMatch) : '';

  const phoneNumberMask = (value: string) => {
    // Remove all non-digits
    const digits = value.replace('+1', '').replace(/\D/g, '');

    // Format to +1(XXX) XXX-XXXX
    let maskedPhoneNumber = digits;
    if (digits.length > 3 && digits.length <= 6) {
      maskedPhoneNumber = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else if (digits.length > 6) {
      maskedPhoneNumber = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }

    return `+1${maskedPhoneNumber}`;
  };

  return (
    <SVTextInput
      disabled={disabled}
      name={name}
      label={label}
      valueFormatter={phoneNumberMask}
      htmlInputProps={{
        inputMode: 'numeric',
      }}
      rules={
        bypassValidation
          ? undefined
          : {
              required: true,
              validate: validateMatch
                ? (value: string) => {
                    return value === matchValue || 'Phone numbers must match';
                  }
                : undefined,
            }
      }
    />
  );
}
